<template>
  <div>
    <keep-alive>
      <component :is="enter" :changes="changes"></component>
    </keep-alive>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: 0,
    };
  },
  components: {
    // 调查问卷首页
    answerExamPage: () => import("./components/answerExamPage.vue"),
    // 新增试卷页面
    makeAnswerExam: () => import("./components/makeAnswerExam.vue"),
    // 获取调查问卷用户信息
    answerSubmitUserDetail: () => import("./components/answerSubmitUserDetail.vue"),
  },
  computed: {
    enter() {
      switch (this.isActive) {
        case 0:
          return "answerExamPage";
        case 1:
          return "makeAnswerExam";
        case 2:
          return "answerSubmitUserDetail";
      }
      return "page";
    },
  },
  methods: {
    changes(index) {
      this.isActive = index;
    },
  },
};
</script>
